import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | {
        authorizedResourceAccess?: AuthorizedResourceAccessMap;
        currentTenantIsAdmin?: boolean;
      }
    | undefined,
) {
  const { authorizedResourceAccess, currentTenantIsAdmin } = initialState ?? {};
  // 与后端 @RequireAdmin(AdminLevel.ORG) 同一口径：当前企业 organizations[].isAdmin，不看 IAM 资源授权
  const orgAdmin = currentTenantIsAdmin === true;

  if (orgAdmin) {
    return new Proxy(
      {
        ...(authorizedResourceAccess ?? {}),
        orgAdmin,
      } as AuthorizedResourceAccessMap,
      {
        get(target, prop: string | symbol) {
          if (typeof prop === 'symbol') {
            return Reflect.get(target, prop);
          }

          return target[prop] ?? true;
        },
      },
    );
  }

  return {
    ...(authorizedResourceAccess ?? {}),
    orgAdmin,
  };
}
